<template>
  <div class="app-footer">
    <div class="app-footer-content common-width">
      <div class="footer-company-info">
        <div class="titile0">上海洞见信息科技有限公司</div>

        <div v-for="info in companyInfo">
          <img class="title-icon" :src="require('@/assets/images/'+info.infoSrc)"/>
          <div class="titile1" v-html="info.title"/>
        </div>
      </div>
      <div class="footer-user-info">
        <el-input v-model="username" placeholder="您的姓名" class="input0"/>
        <el-input v-model="phone" placeholder="您的电话" class="input0"/>
        <el-input v-model="email" placeholder="您的邮箱" class="input0"/>
        <el-input v-model="leavingMsg" type="textarea" placeholder="留言内容" class="input2" rows="4" resize="none"/>
        <el-button type="primary" style="margin-left: 490px;margin-top: 10px" @click="submitClick()">提交</el-button>
      </div>

      <div class="footer-tip-area">
        <a class="footer-tip" @click="funcClick(productPath)">产品中心</a>
        <div class="footer-tip">&ensp;|&ensp;</div>
        <a class="footer-tip" @click="funcClick(newsPath)">新闻中心</a>
      </div>
      <div class="footer-copyright">Copyright © djxinxi.net 上海洞见信息科技有限公司版权所有 沪ICP备2022020506号-1</div>
      <div></div>
    </div>
  </div>
</template>

<script>
import {ref}  from "vue"
import {useRouter}  from "vue-router"
import constants from "@/api/constants";
import { ElMessage } from "element-plus";

export default {
  name: "FooterView",
  setup(){
    const router = useRouter();
    const username = ref("");
    const phone = ref("");
    const email = ref("");
    const leavingMsg  = ref("");
    function funcClick(routerPath) {
      router.push({ path: routerPath});
    }
    const productPath = constants.navData[1].path;
    const newsPath = constants.navData[2].path;
    const companyInfo = [
      {
        infoSrc:"footer-addess-icon.png",
        title:"地址：上海市闵行区庙泾路66号",
      },
      {
        infoSrc:"footer-addess-icon.png",
        title:"绵阳研发中心：绵阳市涪城区安昌路66号",
      },
      {
        infoSrc:"footer-postal-icon.png",
        title:"邮编：200120",
      },
      {
        infoSrc:"footer-phone-icon.png",
        title:"手机：13816656869",
      },
      {
        infoSrc:"footer-phone-icon.png",
        title:"手机：13918374630",
      },
      {
        infoSrc:"footer-email-icon.png",
        title:"邮件：jason.ho@djxinxi.net",
      },
      {
        infoSrc:"footer-email-icon.png",
        title:"邮件：zhanggong@djxinxi.net",
      },
    ];
    function submitClick(){
      if (!leavingMsg.value || !phone.value || !username.value || !email.value){
        ElMessage({
          message: '请输入相关内容',
          type: 'warning',
        })
      }else {
        username.value = "";
        phone.value = "";
        email.value = "";
        leavingMsg.value = "";
        ElMessage({
          message: "消息提交成功",
          type: "success",
        });
      }
    }

    return{
      funcClick,
      productPath,
      newsPath,
      companyInfo,
      username,
      phone,
      email,
      leavingMsg,
      submitClick,
    }
  }
};
</script>

<style scoped>

.app-footer {
  height: 465px;
  width: 100%;
  background-color: #363636;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding-top: 60px;
  margin-top: 60px;
}

.app-footer-content {
  position: relative;
}

.footer-company-info {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  width: 605px;
}

.footer-user-info {
  width: 605px;
  position: absolute;
  right: 0;
}

.title-icon{
  display: inline-block;
}

.titile0 {
  color: #FFFFFF;
  font-size: 30px;
  line-height: 48px;
}

.titile1 {
  color: #FFFFFF;
  font-size: 16px;
  line-height: 40px;
  display: inline-block;
  margin-left: 20px;
}
.input0{
  width: 500px;
  height: 30px;
  margin-left: 50px;
  margin-top: 20px;
}
.input2{
  width: 500px;
  height: 100px;
  margin-left: 50px;
  margin-top: 20px;
}
.input0:nth-child(1){
  margin-top: 10px;
}
.footer-tip-area{
  position: absolute;
  width: 100%;
  bottom: 58px;
  display: flex;
  justify-content: center;
}

.footer-tip{
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.footer-copyright{
  color: white;
  text-align: center;
  position: absolute;
  font-size: 12px;
  width: 100%;
  bottom: 25px;
}
</style>
